import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/contacts/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/contacts/ContactMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/LeafletStyles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
